import showcaseActionKeys from './showcaseActionKeys';
import showcaseService from './showcaseService';

export const attachReview = (serviceProviderId, showcaseId, reviewId) => ({
  type: showcaseActionKeys.ATTACH_REVIEW,
  payload: showcaseService.attachReview(serviceProviderId, showcaseId, reviewId),
});

export const attachReviewReset = () => ({
  type: showcaseActionKeys.ATTACH_REVIEW_RESET,
});

export const getCategories = (serviceProviderId, searchText, limit) => ({
  type: showcaseActionKeys.GET_CATEGORIES,
  payload: showcaseService.getCategories(serviceProviderId, searchText, limit),
});

export const getShowcase = (serviceProviderId, showcaseId) => ({
  type: showcaseActionKeys.GET_SHOWCASE,
  payload: showcaseService.getShowcase(serviceProviderId, showcaseId),
});

export const getShowcaseReset = () => ({
  type: showcaseActionKeys.GET_SHOWCASE_RESET,
});

export const getReviews = request => ({
  type: showcaseActionKeys.GET_REVIEWS,
  payload: showcaseService.getReviews(request),
});

export const getReviewsReset = () => ({
  type: showcaseActionKeys.GET_REVIEWS_RESET,
});

export const saveShowcase = showcaseSubmission => ({
  type: showcaseActionKeys.SAVE_SHOWCASE,
  payload: showcaseService.saveShowcase(showcaseSubmission),
});

export const saveMedia = (files, serviceProviderId, showcaseId) => ({
  type: showcaseActionKeys.SAVE_MEDIA,
  payload: Promise.all(files.map((file, index) =>
    showcaseService.saveMedia(file, serviceProviderId, showcaseId, files.length, index))),
});

export const saveMediaOrder = (mediaIds, serviceProviderId, showcaseId) => ({
  type: showcaseActionKeys.SAVE_MEDIA_ORDER,
  payload: showcaseService.saveMediaOrder(mediaIds, serviceProviderId, showcaseId),
});

export const saveShowcaseOrder = (showcaseIds, serviceProviderId) => ({
  type: showcaseActionKeys.SAVE_SHOWCASE_ORDER,
  payload: showcaseService.saveShowcaseOrder(showcaseIds, serviceProviderId),
});

export const saveMediaReset = () => ({
  type: showcaseActionKeys.SAVE_MEDIA_RESET,
});

export const publishShowcase = (serviceProviderId, showcaseId) => ({
  type: showcaseActionKeys.PUBLISH_SHOWCASE,
  payload: showcaseService.publishShowcase(serviceProviderId, showcaseId),
});

export const deleteMedia = (mediaIds, serviceProviderId, showcaseId) => ({
  type: showcaseActionKeys.DELETE_MEDIA,
  payload: showcaseService.deleteMedia(mediaIds, serviceProviderId, showcaseId),
});

export const updateShowcaseMedia = (
  refetchShowcase,
  description,
  serviceProviderId,
  showcaseId,
  mediaId,
  file,
) => ({
  type: showcaseActionKeys.UPDATE_SHOWCASE_MEDIA,
  payload:
    showcaseService.updateShowcaseMedia(description, serviceProviderId, showcaseId, mediaId, file),
  meta: {
    refetchShowcase,
  },
});

export const updateShowcaseMediaReset = () => ({
  type: showcaseActionKeys.UPDATE_SHOWCASE_MEDIA_RESET,
});

export const addImageFromGallery = (serviceProviderId, imageId, showcaseId) => ({
  type: showcaseActionKeys.ADD_IMAGE_FROM_GALLERY,
  payload: showcaseService.addImageFromGallery(serviceProviderId, imageId, showcaseId),
});

export const addImageFromGalleryReset = () => ({
  type: showcaseActionKeys.ADD_IMAGE_FROM_GALLERY_RESET,
});

export default {
  attachReview,
  attachReviewReset,
  getCategories,
  getShowcase,
  getShowcaseReset,
  getReviews,
  getReviewsReset,
  saveShowcase,
  saveMedia,
  saveMediaOrder,
  saveMediaReset,
  saveShowcaseOrder,
  publishShowcase,
  deleteMedia,
  addImageFromGallery,
  addImageFromGalleryReset,
  updateShowcaseMedia,
  updateShowcaseMediaReset,
};



// WEBPACK FOOTER //
// ./src/modules/showcase/common/showcaseActions.js